import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';

export const fetchCoveredBoundsCountries = async () => {
  return fetchApi(`/storefront/issues/coveredbonds/countries`)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const fetchCoveredBoundsDocuments = async () => {
  return fetchApi(`/storefront/coveredbonds/documents`)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const fetchCoveredBoundsSeniorityRatings = async () => {
  return fetchApi(`/storefront/issues/coveredbonds/senioritytypes`)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};
